import {HeaderTitle} from '@/components/atoms'
import {Header as HeaderConst} from '@/utils/constants/header'
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {useGeneralDetails} from './GeneralDetailsSection-hook'

export const GeneralDetailsSection = ({generalDetails}) => {
  const {generalDetailsJsonSchema, generalDetailsUISchema} = useGeneralDetails()
  const getVal = v => v || '-'
  return (
    <div className="mt-6">
      <HeaderTitle title="General Details" headingLevel={HeaderConst.SectionTitle} className="sectionTitle pl-4 pr-4" />
      <div className="divider mb-5 mt-5" />
      <div className="generalDetailsSection pl-4 pr-4">
        <JsonFormsWrapper
          jsonschema={generalDetailsJsonSchema}
          uischema={generalDetailsUISchema}
          data={{
            product: getVal(generalDetails?.product),
            sourceOnlineLineId: getVal(generalDetails?.sourceOnlineLineId),
            meterialUOM: getVal(generalDetails?.meterialUOM),
            saleUOM: getVal(generalDetails?.saleUOM),
            baseUOM: getVal(generalDetails?.baseUOM),
            alternativeOrderLineNumber: getVal(generalDetails?.alternativeOrderLineNumber),
            itemCategoryId: getVal(generalDetails?.itemCategoryId),
            itemCategoryType: getVal(generalDetails?.itemCategoryType),
            conversionMultiplierToBase: getVal(generalDetails?.conversionMultiplierToBase),
          }}
        />
      </div>
    </div>
  )
}
